/**
 * Application Entry Point
 * 
 * This is the main entry file that bootstraps the React application.
 * It renders the App component into the DOM and wraps it with
 * necessary providers.
 */

import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import './index.css'

// Get the root element from the DOM
const rootElement = document.getElementById('root')

// Ensure the root element exists before rendering
if (!rootElement) {
  throw new Error('Root element not found. Make sure there is a div with id="root" in your HTML.')
}

// Create React root and render the application
// StrictMode helps identify potential problems in development
ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    {/* BrowserRouter enables client-side routing */}
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
)
